import React from 'react';
import { Flex } from '@ui-library/misc';
import { EditableInput } from '@ui-library/dynamicInput/style';

interface AddTraitInputProps {
  onChange: (value: { key: string; value: string }) => void;
}
const AddTraitInput: React.FC<AddTraitInputProps> = ({ onChange }: AddTraitInputProps) => {
  const [value, setValue] = React.useState({ key: '', value: '' });

  return (
    <Flex>
      <EditableInput
        style={{ margin: '4px', padding: '5px 10px' }}
        placeholder="Constant key"
        onChange={(e) => {
          const val = { ...value, key: e.target.value };
          setValue(val);
          onChange(val);
        }}
      />
      <div style={{ marginRight: 4 }} />
      <EditableInput
        placeholder="Constant value"
        style={{ margin: '4px', padding: '5px 10px' }}
        onChange={(e) => {
          const val = { ...value, value: e.target.value };
          setValue(val);
          onChange(val);
        }}
      />
    </Flex>
  );
};

export default AddTraitInput;
